<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Feminist Search Tools</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Data visualisation, research, web tools, digital libraries, commissioned work</p>
<p>Feminist Search Tools is an ongoing artistic research project that explores different ways of engaging with the items of digital library catalogues and their systems of categorization. The project attempts to stir conversations around the inclusion and exclusion mechanisms that are inherent to current Western knowledge economies.</p>
<p>Together with <a href="http://w-i-t-m.net/"> Angeliki Diakrousi</a>, I worked on further developing and complexifying the existing visualisation tool built by the design team during Digital Methods Summer School 2019, Amsterdam. The tool is built using D3js and uses as database the catalogue of IHLIA. The code can be found <a href="https://github.com/alicestrt/fst-viz-tool">here</a>.</p>
<p> The project is part of a long-term collaboration between the two collectives <a href="https://read-in.info/">Read-in</a> and <a href="https://hackersanddesigners.nl/">Hackers & Designers</a>. The Feminist Search Tools work group consists of: Read-in (Annette Krauss, Svenja Engels, Laura Pardo), Hackers & Designers, (Anja Groten, André Fincato, Heerko van der Kooij, and and previous member James Bryan Graves), Ola Hassanain, Angeliki Diakrousi and Alice Strete. </p>

      </div>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col md="10" offset-md="1">
        <b-img class="img-fluid" src="media/fst/fst-website-4.jpg"></b-img>
      </b-col>
    </b-row>

        <b-row>
      <b-col md="10" offset-md="1">
      <b-img class="img-fluid" src="media/fst/fst-website-12.jpg"></b-img>

      </b-col>
    </b-row>
</b-col>
</b-row>
  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'FSTPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
